import api from '@/lib/api'

export interface Plan {
  id: string
  name: string
  price: number
  predictions_limit: number | string
  models_limit: number | string
  data_sources_limit: number | string
  users_limit: number
  features: string[]
}

export interface Usage {
  predictions_used: number
  predictions_limit: number | string
  models_used: number
  models_limit: number | string
  data_sources_used: number
  data_sources_limit: number | string
  users_used: number
  users_limit: number
}

export interface CurrentPlanResponse {
  plan: Plan
  usage: Usage
}

export interface CheckoutSessionResponse {
  checkout_url: string
}

export interface PortalSessionResponse {
  portal_url: string
}

export interface SubscriptionStatus {
  has_subscription: boolean
  status: string | null
  current_period_end: string | null
  cancel_at_period_end: boolean
  is_in_grace_period: boolean
  grace_period_ends_at: string | null
}

export const billingService = {
  async getPlans(): Promise<Plan[]> {
    const { data } = await api.get<Plan[]>('/billing/plans')
    return data
  },

  async getCurrentPlan(): Promise<CurrentPlanResponse> {
    const { data } = await api.get<CurrentPlanResponse>('/billing/current')
    return data
  },

  async getUsage(): Promise<Usage> {
    const { data } = await api.get<Usage>('/billing/usage')
    return data
  },

  async createCheckoutSession(planId: string): Promise<CheckoutSessionResponse> {
    const { data } = await api.post<CheckoutSessionResponse>('/billing/checkout', {
      plan_id: planId,
    })
    return data
  },

  async createPortalSession(): Promise<PortalSessionResponse> {
    const { data } = await api.post<PortalSessionResponse>('/billing/portal')
    return data
  },

  async getSubscriptionStatus(): Promise<SubscriptionStatus> {
    const { data } = await api.get<SubscriptionStatus>('/billing/subscription-status')
    return data
  },
}
